<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import forminput from "@/router/views/FormComponet/forminput.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import OKurumSabit from "@/models/OKurumSabit";

export default {
  mixins: [Api, Sabit, OKurumSabit],
  page: {
    title: "E-Bütçe Şifre",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    forminput,
  },
  data() {
    return {
      title: this.$t("OKurumSabit.Title"),
      items: [
        {
          text: this.$t("OKurumSabit.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("OKurumSabit.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("OKurumSabit.Title"),
          active: true,
        },
      ],
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: [],
      FormData: {},
    };
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.Update("OKurumSabit", this.FormData);
      }
    },
    Get() {
      this.ActionsGet({ Service: "OKurumSabit", Page: this.Page }).then((res) => {
        this.FormData = res.Data[0];
      });
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <Form @submit.prevent="onSubmit">
              <forminput :FormDataType="FormDataType.EButceKullaniciAdi" :Value="FormData.EButceKullaniciAdi" :v="$v.FormData.EButceKullaniciAdi" @input="FormData.EButceKullaniciAdi = $event" />
              <forminput :FormDataType="FormDataType.EButceSifre" :Value="FormData.EButceSifre" :v="$v.FormData.EButceSifre" @input="FormData.EButceSifre = $event" />
              <button class="btn btn-primary" type="submit">{{ $t("OKurumSabit.AddEdit.Button") }}</button>
            </Form>
          </div>
        </div>
      </div>
    </Layout>
  </Loader>
</template>
